import { msg } from '@lingui/core/macro';
import { fetchTmBoard } from 'modules/board-master/store/tm-board/actions';
import checkInitTime from 'modules/board-master/store/tm-board/handlers/check-init-time';
import * as syncAction from 'modules/board-master/store/tm-board/tmBoard';
import { setIsTimerStart, setTime } from 'modules/board-master/store/tm-board/tmBoard';
import { TMBoard } from 'modules/core/domain/interfaces/supabase/tm-boards/entity';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch } from 'store/store';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';
import supabase from 'modules/core/supabase/supabase';

function useParseSupabase() {
  const dispatch = useDispatch<AppDispatch>();
  const dispatchWithToast = useDispatchWithToast();
  const id = useParams()?.id;

  const setData = useCallback(
    (board: TMBoard) => {
      dispatch(
        syncAction.setData({
          period: board.period,
          score: board.score,
          teams: board.teams,
          isReverse: board.isReverse,
        }),
      );

      const time = checkInitTime(board.time, board.startTime, board.isReverse);
      dispatch(setTime({ milliseconds: time }));
      dispatch(setIsTimerStart({ isTimerStart: Boolean(board.startTime) }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (!id) return;
    dispatchWithToast(fetchTmBoard({ id }), { error: msg`Не удалось получить данные о табло` });
  }, [dispatchWithToast, id]);

  useEffect(() => {
    if (!id) return;

    supabase.tmBoards.observeChanges(id);
    return () => {
      supabase.tmBoards.stopObserveChanges();
    };
  }, [id]);

  useEffect(() => {
    supabase.tmBoards.data.subscribe((board) => {
      if (!board) return;
      setData(board);
    });
  }, [dispatch, setData]);
}

export default useParseSupabase;
